import ConversionResult from './conversionResult.js';

class ConversionError extends ConversionResult{
    constructor(baseValue, conversionError, quantity, baseUnit, targetUnit){
        super(baseValue, undefined, quantity, baseUnit, targetUnit);
        this.error = conversionError;
    }
}

export default ConversionError;